import React, { useEffect } from "react";
import Navbar from "../../shared/Navbar/Navbar";
import Footer from "../../shared/Footer/Footer";
import "../../../style/projects/fpProject.css";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const FPProject = () => {
  useEffect(() => {
    document.title = `Development Concern | Nursery Development Project`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/the-ain-shohayota-activity";

  return (
    <div>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="ndp_project_section">
        <div className="header_image">
          <p>Home | Projects | Ongoing Project</p>
          <h2>Fish Production Project </h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2>Project Demo</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">
          <h3>Fish Production Project </h3>
          <div className="content_wrapper">
            <table>
              <thead>
                <tr>
                  <th>SL No</th>
                  <th>Name of Content</th>
                  <th colSpan={4}>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Project Name</td>
                  <td colSpan={4}>Fish Production Project </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Name of Donor</td>
                  <td colSpan={4}>Organization’s Own Fund</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Total Budget:</td>
                  <td colSpan={4}>22,00,000 Taka</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Working Area</td>
                  <td colSpan={4}>
                    Rangamati Sadar
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Major Focuses</td>
                  <td colSpan={4}>
                    Ensuring sustainable fish cultivation as a reliable source of protein
                  </td>

                  {/* <tr>
                  <td>4</td>
                  <td>Duration</td>
                  <td>Date Started</td>
                  <td>2023</td>
                  <td>Date End</td>
                  <td>2026</td>
                </tr> */}
                  {/* <tr>
                  <td>5</td>
                  <td>Total Beneficiary</td>
                  <td colSpan={4}>Marginalise and vulnerable people</td>
                </tr> */}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FPProject;
